import { OrderedMap } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { SEARCH_ITEMS } from './actions'

export const INITIAL_STATE = new OrderedMap({
  todayItems: [],
  tomorrowItems: [],
  logItems: [],
})

// export const searchSchema = new schema.Entity('search', {}, { idAttribute: 'startedAt' })

export const search = createReducer(INITIAL_STATE, {
  [SEARCH_ITEMS.FULFILLED]: (state, { payload }) => new OrderedMap(payload),
})



// WEBPACK FOOTER //
// ./src/modules/search/reducers.js